import { render, staticRenderFns } from "./CRUDEscalas.vue?vue&type=template&id=391553aa&"
import script from "./CRUDEscalas.vue?vue&type=script&lang=js&"
export * from "./CRUDEscalas.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports